module.exports = __webpack_public_path__ + "f59dbc0cf4dee90b20374f6bf6125d42.pdf";